const validResidentialStatuses = [
  '',
  'OWNER',
  'TENANT PRIVATE',
  'TENANT PUBLIC',
  'LIVING WITH PARENTS',
  'LIVING WITH FRIENDS',
  'LEASEHOLD',
  'HOMEOWNER WITH MORTGAGE',
  'HOMEOWNER NO MORTGAGE'
];

/**
 * Maps customer residential_status data to a list of known valid values or an empty string value.
 * @param {String} input
 */
function mapResidentialStatus(input) {
  if (!input || !validResidentialStatuses.includes(input)) {
    return validResidentialStatuses[0];
  }
  return input;
}

export { mapResidentialStatus };
